import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Icon } from 'tea-component';
import './index.scss';

type TAlertStatus = 'error' | 'warning';

interface IUserFilterAlertProps {
  title: string;
  description?: ReactNode;
  status?: TAlertStatus;
  iconName?: string;
  className?: string;
  style?: React.CSSProperties;
}

const AlertCard: React.FC<IUserFilterAlertProps> = ({
  title,
  description,
  status = 'error',
  iconName,
  className = '',
  style,
}) => {
  const containerClass = classNames(
    'dbl-alert-card',
    status ? `dbl-alert-card--${status}` : null,
    className,
  );

  return (
    <div className={containerClass} style={style}>
      <div className="dbl-alert-card__title">
        <Icon type={iconName || status} className="dbl-alert-card__icon"/>
        <p>{title}</p>
      </div>
      {description ? (
        <p className="dbl-alert-card__description">{description}</p>
      ) : null}
    </div>
  );
};

export default AlertCard;

